module.exports = __webpack_public_path__ + "static/media/compass.2c5b72a2.svg";